

import { Component, Mixins, VModel } from 'vue-property-decorator';
import IBPaymentCardProps from "@/components/IBPayment/mixins/IBPaymentCardProps";
import { IPaymentCard } from "@/components/IBPayment/interface";

import IBPaymentCardContent from "@/components/IBPayment/IBPaymentCardContent.vue";
import IBModal from '@/components/Modal/IBModal.vue';

@Component({
	components: {
		IBPaymentCardContent,
		IBModal
	}
})
export default class IBPaymentDetailActionSheet extends Mixins(IBPaymentCardProps) implements IPaymentCard {

	@VModel({ type: Boolean, default: false })
	active!: boolean

}

